
                import Handlebars from 'handlebars/dist/handlebars.runtime';
                const templateFunction = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class='backdrop' id='backdrop'>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</div>";
},"useData":true});
                export default templateFunction;
                